import dayjs from "dayjs";

export const obtenerMesesTranscurridos = (bolsillo) =>{

    let fechaHoy = dayjs()
    let fechainicio = dayjs(bolsillo.fecha)

    const mesesCompletos = fechainicio.diff(fechaHoy, 'month');

    return mesesCompletos;

}